import React from 'react'
import {Group} from "../../../../../data-structures/group";

type Props = {
    group               : Group
    addedColumnsIds?    : ID[]

    selected?           : boolean

    onSelectSection     : func
}

export default class MenuItem extends React.Component<Props> {

    onSelectSection = () => {
        this.props.onSelectSection(this.props.group.value)
    }

    render() {
        const counter = _.intersection(this.props.addedColumnsIds, this.props.group.items).length

        return (
            <div className={Classes("item", {selected: this.props.selected})} onClick={this.onSelectSection}>
                <div className="row">
                    <div className="name">{this.props.group.label}</div>
                    {counter > 0 && <div className="counter">{counter}</div>}
                </div>
            </div>
        )
    }
}
